import { createAsyncThunk } from '@reduxjs/toolkit';
import { postJoinExistingEmployeeToProject } from '../services/postJoinExistingEmployeeToProject.service';

export const joinExistingEmployeeToProject = createAsyncThunk(
  'resources/joinExistingEmployeeToProject',
  async (joinData) => {
    const { projectId, userId, employerBusinessId } = joinData;

    const response = await postJoinExistingEmployeeToProject({
      projectId,
      userId,
      employerBusinessId,
    });
    return response;
  }
);
